/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { CultureService } from '../../../services/culture.service';
import { DEFAULT_APP_CULTURE_CODE } from '../../../languages/language.model';

@Component({
    selector: 'app-culture-code-field',
    templateUrl: './culture-code-field.component.html',
    styleUrls: ['./culture-code-field.component.scss'],
    standalone: false
})
export class CultureCodeFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;

  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  isReadOnly: boolean;
  @Input() dataset: Dataset;
  displayValue: string;

  get value(): any {
    return this._value;
  }

  set value(val: any) {
    if (!val) {
      val = DEFAULT_APP_CULTURE_CODE;
    }

    this.displayValue = this.cultureService.getTranslateService().instant(`LANGUAGES.LANGUAGE-${val}`);

    this._value = val;
  }

  private _value: any = null;

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = false;
  }

  constructor(private cultureService: CultureService) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    const fieldValue = this.reader.getFieldValue(this.field.systemName) || DEFAULT_APP_CULTURE_CODE;
    this.value = fieldValue;

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }
}
